module.exports = __webpack_public_path__ + "mainassets/img/404-number.346e9d5a.svg";